import { useContext, useEffect, useState } from "react";
import { RecruitmentContext } from "./Recruitment_From";
import { Divider, Grid } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { InputNumberForm, SelectFormItem, TextBoxForm } from "components/Input";
import { BtnSaveIcon } from "components/Button";
import Accordion from "components/Accordion";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { undefinedOrNull } from "utilities/Function";
import { List } from "linqts";
import { FnBlock_UI } from "components/BlockUI";
import { AxiosPost } from "utilities/Axios";
import { SwAlert } from "components";
import { AlertMsg, AlertTitle } from "config/AlertMsgConfig";
const Assessment_From = () => {
    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const { objMasterData } = useContext(RecruitmentContext);
    const [lstAssessment, setlstAssessment] = useState([]);
    const lstScore = [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
        { value: 5, label: "5" },
        { value: 6, label: "6" },
        { value: 7, label: "7" },
        { value: 8, label: "8" },
        { value: 9, label: "9" },
        { value: 10, label: "10" }
    ];

    const [objSchema, setobjSchema] = useState(
        yup.object().shape({
            sAssessmentDescription: yupFormSchemas.string("", { required: false }),
        })
    );

    useEffect(() => {
        setlstAssessment(objMasterData?.objAssessment?.lstAssessment || []);
        form.setValue("sAssessmentDescription", objMasterData?.objAssessment?.sAssessmentDescription);
        console.log("lstAssessment", objMasterData?.objAssessment);
        if ((objMasterData?.objAssessment?.lstAssessment || []).length > 0) {
            const nTotal = new List<any>((objMasterData?.objAssessment?.lstAssessment || [])).Sum(s => s.nScore);
            form.setValue("nTotal", nTotal);

            const _objSchema = { sAssessmentDescription: yupFormSchemas.string("", { required: false }) };
            (objMasterData?.objAssessment?.lstAssessment || []).forEach(element => {
                _objSchema["nScore_" + element.nAssessmentID] = yupFormSchemas.string("", { required: false })
                form.setValue("nScore_" + element.nAssessmentID, element.nScore);
            });
            setobjSchema(yup.object().shape(_objSchema));
        }
    }, [objMasterData?.objAssessment?.lstAssessment])

    const form = useForm({
        resolver: yupResolver(objSchema),
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });

    const onSave = () => {

        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmSave, () => {
            BlockUI();
            let obj = {
                nRegisterID: objMasterData?.objData?.objFormData?.nRegisterID,
                lstAssessment: lstAssessment || [],
                sAssessmentDescription: undefinedOrNull(form.getValues("sAssessmentDescription"), "string")
            }
            AxiosPost("UserRecruitment/onSaveAssessment", obj, (res) => {
                SwAlert.Success(AlertTitle.Success, AlertMsg.SaveComplete, () => {

                });
            }, null, null, null, () => {
                UnBlockUI();
            })
        });
    };

    const onChangeScore = () => {
        const nTotal = new List<any>(lstAssessment).Sum(s => s.nScore);
        form.setValue("nTotal", nTotal);
    }
    return (
        <Grid item md={12}>
            <Accordion header="ประเมินผลของผู้สัมภาษณ์" isExpanded>
                <Grid container direction="row" xs={12} md={12} spacing={2} marginBottom={1}>
                    <FormProvider {...form}>
                        <Grid item md={12} xs={12}>
                            <table style={{ width: "80%" }}>
                                <tbody>
                                    {lstAssessment?.map(m => {
                                        return (
                                            <tr>
                                                <td style={{ width: "200px", paddingTop: "10px" }}>{m.sAssessmentName}</td>
                                                <td style={{ width: "100px", paddingTop: "10px" }}><SelectFormItem disabled={!objMasterData.isEditData}
                                                    name={"nScore_" + m.nAssessmentID} label={"คะแนน"}
                                                    required options={lstScore}
                                                    onChange={(e) => {
                                                        if (e) {
                                                            m.nScore = undefinedOrNull(e.value, "number");
                                                        } else {
                                                            m.nScore = null;
                                                        }
                                                        onChangeScore();
                                                    }} /></td>
                                            </tr>
                                        )
                                    })}
                                    <tr>
                                        <td style={{ width: "200px", paddingTop: "10px", textAlign: "end", paddingRight: "20px" }}>คะแนนรวม</td>
                                        <td style={{ width: "100px", paddingTop: "10px" }}><InputNumberForm name="nTotal" disabled /></td>
                                    </tr>
                                </tbody>
                            </table>

                        </Grid>
                        <Grid item md={12} xs={12}>
                            <TextBoxForm name="sAssessmentDescription" multiline rows={5} label="เพิ่มเติม" disabled={!objMasterData.isEditData} />
                        </Grid>
                    </FormProvider>
                    <Grid item md={12} xs={12} marginTop={1} marginBottom={1}>
                        <Divider></Divider>
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <p style={{ fontSize: "12px" }}>แก้ไขโดย :  {objMasterData?.objAssessment?.sUpdateName || "-"}</p>
                        <p style={{ fontSize: "12px" }}>วันที่แก้ไข : {objMasterData?.objAssessment?.sUpdateDate || "-"}</p>
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <Grid marginTop={4} md={12} container direction="row" alignItems="center" justifyContent="center" sx={{}}>
                           {objMasterData.isEditData&&<BtnSaveIcon style={{ width: "130px", marginLeft: "10px" }} onClick={form.handleSubmit(() => { onSave(); })} />}
                        </Grid>
                    </Grid>
                </Grid>
            </Accordion>
        </Grid>
    );
}

export default Assessment_From;